"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTile = void 0;
var product_tile_component_1 = require("./product-tile.component");
Object.defineProperty(exports, "ProductTile", { enumerable: true, get: function () { return product_tile_component_1.ProductTile; } });
